import { render, staticRenderFns } from "./CaixaDeTexto.vue?vue&type=template&id=70c587cb"
import script from "./CaixaDeTexto.vue?vue&type=script&lang=js"
export * from "./CaixaDeTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports